export const TYPE_GENERAL = 1
export const TYPE_EVENT = 2
export const TYPE_VOUCHER = 3
export const TYPE_POLL = 4
